import { render } from "./StoreRating.vue?vue&type=template&id=725d2597&scoped=true"
import script from "./StoreRating.vue?vue&type=script&lang=js"
export * from "./StoreRating.vue?vue&type=script&lang=js"

import "./StoreRating.vue?vue&type=style&index=0&id=725d2597&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725d2597"]])

export default __exports__